import { Dayjs } from 'dayjs'

import { getToday } from './getToday'
import { isAfter } from './isAfter'

export function isFutureMonth(date: Dayjs, relativeTo: Dayjs = getToday()): boolean {
    return isAfter(date, relativeTo.endOf('month'), 'month')
}
